import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import DeliveryInfo from '../../components/DeliveryInfo';
import DeliveryInfoUkr from '../../components/DeliveryInfoUkr';

interface Props {
  title: string;
  description: string;
  // highlights: string[];
  materials: string[];
}

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function ItemDetailsAccordion(props: Props) {
  const [expanded, setExpanded] = React.useState<string | false>('panel1');
  const { t, i18n } = useTranslation();

  let isEnglish = i18n.language === "en";
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  // const listItems = props.highlights.map(h => <li><Typography variant='body1' padding={'4px 0px 4px 0px'}>{h}</Typography></li>);
  const listMaterials = props.materials.map(h => <li><Typography variant='body1' padding={'4px'}>{h.toLocaleUpperCase()}</Typography></li>);
  return (
    <div>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>{t('details.about-product').toLocaleUpperCase()}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box display='flex' columnGap={4} flexWrap={'wrap'}>
            <Box flex='1 1 100%'>
              <Typography variant='h5'>
                {props.title}
              </Typography>
            </Box>
            <Box flex='1 1 60%' marginTop={2}>
              <Typography variant='caption' margin='10px 0'>
                {t('details.description').toLocaleUpperCase()}
              </Typography>
              <Typography variant='body1'>
                {props.description}
              </Typography>
              {/* <Typography variant='body1'>
                <ul>{listItems}</ul>
              </Typography> */}
            </Box>
            <Box marginTop={2} flex={{ xs: '1 1 50%', md: '1 1 10%' }} >
              <Typography margin='10px 0' variant='caption' >
                {t('details.materials').toLocaleUpperCase()}
              </Typography>
              <Box marginLeft={-5} marginTop={-2}>
                <ul className='materials'>{listMaterials}</ul></Box>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography>{t('details.delivery').toLocaleUpperCase()}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {isEnglish ? <DeliveryInfo /> : <DeliveryInfoUkr />}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}